"use client";

export { useCopyToClipboard } from "react-use";
